var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as BetStatuses from '../constants/BetStatus';
export var selectForLive = function (state) {
    var path = state.routing.location !== null ?
        state.routing.location.pathname :
        undefined;
    return {
        path: path,
        languageId: state.application.get('languageId'),
        tab: state.application.get('activeTab'),
        version: state.application.getIn(['live', 'version']),
        repoState: state.application.getIn(['live', 'state'])
    };
};
function filterLiveBets(bet) {
    return bet.get('rate').get('isLive');
}
export var selectForLiveBetslips = function (state) {
    var quickBet = state.coupon.get('quickBet').get('bet').filter(filterLiveBets).toJS();
    var betSlips = state.coupon.get('betSlips').filter(filterLiveBets).toJS();
    return {
        languageId: state.application.get('languageId'),
        basket: __assign(__assign({}, betSlips), quickBet)
    };
};
export var selectForLiveMatch = function (state) {
    var path = state.routing.location !== null ?
        state.routing.location.pathname :
        undefined;
    return {
        path: path,
        languageId: state.application.get('languageId'),
        tab: state.application.get('activeTab'),
        version: state.application.getIn(['liveMatch', 'version']),
        repoState: state.application.getIn(['liveMatch', 'state'])
    };
};
export var selectForPopularLive = function (state) {
    var path = state.routing.location !== null ?
        state.routing.location.pathname :
        undefined;
    return {
        path: path
    };
};
export var selectUser = function (state) {
    return {
        user: state.auth.user
    };
};
export var selectForTimetable = function (state) {
    var path = state.routing.location !== null ?
        state.routing.location.pathname :
        undefined;
    return {
        path: path,
        languageId: state.application.get('languageId'),
        version: state.application.getIn(['timetable', 'version']),
        repoState: state.application.getIn(['timetable', 'state'])
    };
};
export var selectForBets = function (state) {
    var couponStatus = state.coupon.get('couponStatus');
    var betArr = [];
    if (couponStatus !== undefined) {
        var status = couponStatus.get('status');
        if (status === BetStatuses.IN_DELAY || status === BetStatuses.STAKE_REQUEST || status === BetStatuses.CONFIRM_AWAIT) {
            var stakeId = couponStatus.get('stakeId');
            var delay = couponStatus.get('delay');
            betArr.push({ stakeId: stakeId, delay: delay });
        }
    }
    return {
        languageId: state.application.get('languageId'),
        bets: betArr
    };
};
export var selectForMultiBets = function (state) {
    var bets = state.coupon.getIn(['couponStatus', 'bets']);
    var betArr = [];
    bets.forEach(function (couponStatus) {
        if (couponStatus !== undefined) {
            var status = couponStatus.get('status');
            if (status === BetStatuses.IN_DELAY || status === BetStatuses.STAKE_REQUEST || status === BetStatuses.CONFIRM_AWAIT) {
                var stakeId = couponStatus.get('stakeId');
                var delay = couponStatus.get('delay');
                betArr.push({ stakeId: stakeId, delay: delay });
            }
        }
    });
    return {
        languageId: state.application.get('languageId'),
        bets: betArr
    };
};
export var selectForQuickBets = function (state) {
    var betHistory = state.coupon.get('quickBet');
    var bet = betHistory.get('bet');
    var betArr = [];
    if (bet !== undefined) {
        var betStatus = betHistory.get('status');
        if (betStatus === BetStatuses.IN_DELAY || betStatus === BetStatuses.STAKE_REQUEST || betStatus === BetStatuses.CONFIRM_AWAIT) {
            var stakeId = betHistory.get('stakeId');
            var delay = betHistory.get('delay');
            betArr.push({ stakeId: stakeId, delay: delay });
        }
    }
    return {
        languageId: state.application.get('languageId'),
        bets: betArr
    };
};



// WEBPACK FOOTER //
// ./src/sagas/selectors.js